import { FC } from 'react'
import { FieldProps } from 'formik'
import ReactSlider from 'react-slider'

/**
 * Use it only with Formik Field component
 * eg.: <FastField name="nbExperiences" label="Number of Experiences" component={FormikRange} min={0} max={1000} />
 */

const FormikRange: FC<FieldProps & { min: number; max: number; label: string }> = (props) => {
  return (
    <div>
      <ReactSlider
        className="slider-track"
        trackClassName="slider-range"
        defaultValue={[props.min, props.max]}
        min={props.min}
        max={props.max}
        ariaLabel={['Lower thumb', 'Upper thumb']}
        ariaValuetext={(state: any) => `Thumb value ${state.valueNow}`}
        renderThumb={(props: any, state: any) => (
          <div
            {...props}
            className="relative -mt-1 h-4 w-4 cursor-pointer rounded-full border-0 bg-brand-500 shadow-sm"
          />
        )}
        pearling
        onChange={(range) => {
          props.form.setFieldValue(props.field.name, {
            min: range[0],
            max: range[1],
          })
        }}
        minDistance={1}
      />
      <div className="mt-5 flex justify-between gap-5">
        <div>
          <label htmlFor="from" className="text-sm font-medium text-gray-700">
            From
          </label>
          <input
            id="from"
            name="from"
            className="input block w-full appearance-none rounded-md bg-white px-3 py-2 placeholder-gray-400 focus:outline-none disabled:bg-gray-50 disabled:text-gray-400 sm:text-sm"
            type="text"
            value={props.field.value.min}
            readOnly
          />
        </div>
        <div>
          <label htmlFor="to" className="text-sm font-medium text-gray-700">
            To
          </label>
          <input
            id="to"
            name="to"
            className="input block w-full appearance-none rounded-md bg-white px-3 py-2 placeholder-gray-400 focus:outline-none disabled:bg-gray-50 disabled:text-gray-400 sm:text-sm"
            type="text"
            value={props.field.value.max}
            readOnly
          />
        </div>
      </div>
    </div>
  )
}

export default FormikRange
